/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMemoryIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-memory"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.35 14.32L8.35 9.68Q8.35 9.13 8.74 8.74Q9.13 8.35 9.68 8.35L14.32 8.35Q14.88 8.35 15.26 8.74Q15.65 9.13 15.65 9.68L15.65 14.32Q15.65 14.88 15.26 15.26Q14.88 15.65 14.32 15.65L9.68 15.65Q9.13 15.65 8.74 15.26Q8.35 14.88 8.35 14.32ZM8.65 20.73L8.65 19.75L6.9 19.75Q5.8 19.75 5.03 18.98Q4.25 18.2 4.25 17.1L4.25 15.35L3.27 15.35Q2.73 15.35 2.34 14.96Q1.95 14.57 1.95 14.03Q1.95 13.47 2.34 13.09Q2.73 12.7 3.27 12.7L4.25 12.7L4.25 11.3L3.27 11.3Q2.73 11.3 2.34 10.91Q1.95 10.53 1.95 9.97Q1.95 9.43 2.34 9.04Q2.73 8.65 3.27 8.65L4.25 8.65L4.25 6.9Q4.25 5.8 5.03 5.03Q5.8 4.25 6.9 4.25L8.65 4.25L8.65 3.27Q8.65 2.73 9.04 2.34Q9.43 1.95 9.97 1.95Q10.53 1.95 10.91 2.34Q11.3 2.73 11.3 3.27L11.3 4.25L12.7 4.25L12.7 3.27Q12.7 2.73 13.09 2.34Q13.47 1.95 14.03 1.95Q14.57 1.95 14.96 2.34Q15.35 2.73 15.35 3.27L15.35 4.25L17.1 4.25Q18.2 4.25 18.98 5.03Q19.75 5.8 19.75 6.9L19.75 8.65L20.73 8.65Q21.27 8.65 21.66 9.04Q22.05 9.43 22.05 9.97Q22.05 10.53 21.66 10.91Q21.27 11.3 20.73 11.3L19.75 11.3L19.75 12.7L20.73 12.7Q21.27 12.7 21.66 13.09Q22.05 13.47 22.05 14.03Q22.05 14.57 21.66 14.96Q21.27 15.35 20.73 15.35L19.75 15.35L19.75 17.1Q19.75 18.2 18.98 18.98Q18.2 19.75 17.1 19.75L15.35 19.75L15.35 20.73Q15.35 21.27 14.96 21.66Q14.57 22.05 14.03 22.05Q13.47 22.05 13.09 21.66Q12.7 21.27 12.7 20.73L12.7 19.75L11.3 19.75L11.3 20.73Q11.3 21.27 10.91 21.66Q10.53 22.05 9.97 22.05Q9.43 22.05 9.04 21.66Q8.65 21.27 8.65 20.73ZM17.1 17.1Q17.1 17.1 17.1 17.1Q17.1 17.1 17.1 17.1L17.1 6.9Q17.1 6.9 17.1 6.9Q17.1 6.9 17.1 6.9L6.9 6.9Q6.9 6.9 6.9 6.9Q6.9 6.9 6.9 6.9L6.9 17.1Q6.9 17.1 6.9 17.1Q6.9 17.1 6.9 17.1Z" fill={color} />
    </svg>
  );
}
